import { useConnectorInfo, useConnectorLoading } from '@/contexts';
import { actionNameKey } from './useWorkflowConnectors';
import type { SelectedNode } from '@/stores/nodeEditorStore';

export function getNodeActionName(node: Pick<SelectedNode, 'type' | 'name' | 'innerActionName'>): string {
  return node.type === 'tool' ? node.innerActionName ?? node.name : node.name;
}

/** Shared by the editor header and About; tool names are not operation lookup keys. */
export function useNodeConnectorInfo(node: SelectedNode | null) {
  const inputs = node?.nodeData && 'inputs' in node.nodeData ? node.nodeData.inputs : undefined;
  const host = inputs && typeof inputs === 'object' && 'host' in inputs ? inputs.host : undefined;
  const connection = host && typeof host === 'object' && 'connection' in host ? host.connection : undefined;
  const referenceName = connection && typeof connection === 'object' && 'referenceName' in connection
    && typeof connection.referenceName === 'string' ? connection.referenceName : undefined;
  const byConnection = useConnectorInfo(referenceName);
  const byAction = useConnectorInfo(actionNameKey(node ? getNodeActionName(node) : ''));
  const isLoading = useConnectorLoading();
  return { connectorInfo: byConnection ?? byAction, connectionRef: referenceName, isLoading };
}
